export default "__VITE_ASSET__Brxb5lVt__"